<template>
  <div class="postavitev-info-top">
    <div class="info-okvir">
      <div class="postavitev-info-icone">
        <i class="fa fa-info-circle"></i>
      </div>
      <div class="postavitev-info-tekst">
        <p class="modra-barva-info">
          Mobilna številka je del vašega naročenega paketa, zato sprememba ni možna.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoKomponentaMobilnaDelPaketa'
}
</script>

<style scoped>
.postavitev-info-top {
  height: 100%;
  padding-top: 30px;
}

.info-okvir {
  width: 380px;
  height: 85px;
  display: flex;
}

@media only screen and (max-width: 1100px) {
  .postavitev-info-icone {
    padding-bottom: 0;
  }

  .info-okvir {
    width: 100%;
    height: 100%;
  }

  .postavitev-info-top {
    height: unset;
    top: unset;
    left: unset;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/InfoKomponentaMobilnaDelPaketa.vue